import { makeVar } from '@apollo/client';
import { ApolloLink, Observable } from '@apollo/client/core';

export const activeApolloRequestsVar = makeVar(0);

function incrementActiveApolloRequests() {
  activeApolloRequestsVar(activeApolloRequestsVar() + 1);
}

function decrementActiveApolloRequests() {
  activeApolloRequestsVar(Math.max(0, activeApolloRequestsVar() - 1));
}

export const apolloNetworkStatusLink = new ApolloLink((operation, forward) => {
  if (!forward) {
    return null;
  }

  incrementActiveApolloRequests();

  return new Observable((observer) => {
    let isSettled = false;

    const finalizeRequest = () => {
      if (isSettled) {
        return;
      }

      isSettled = true;
      decrementActiveApolloRequests();
    };

    const subscription = forward(operation).subscribe({
      next: (value) => observer.next(value),
      error: (error) => {
        finalizeRequest();
        observer.error(error);
      },
      complete: () => {
        finalizeRequest();
        observer.complete();
      },
    });

    return () => {
      finalizeRequest();
      subscription.unsubscribe();
    };
  });
});
